import clsx from 'clsx';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

import styles from './Link.module.scss';

type LinkProps = NextLinkProps & {
    children: React.ReactNode;
    className?: string;
    target?: string;
};

export const Link: React.FC<LinkProps> = ({ children, className, target, ...props }) => (
    <NextLink
        className={clsx(styles.root, className)}
        target={target}
        {...props}
    >
        {children}
    </NextLink>
);
